export default "__VITE_ASSET__4lfjU99D__"